module.exports = __webpack_public_path__ + "8895ad2af06366b00456e5959143d137.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/directory-groups/directory-groups-side-menu/directory-groups-side-menu.html
// module id = 1983
// module chunks = 0